import { BaseMapper } from '@ps/utils';
import { IrGeneratorResponseDto } from '../dtos/ir-generator.dto';

// Inbound mapper — maps API response DTO to domain model.
// Direction: API DTO → Domain model
export class IrGeneratorMapper extends BaseMapper<
  IrGeneratorResponseDto,
  string
> {
  public fromDto(dto: IrGeneratorResponseDto): string {
    return dto.response;
  }
}
